import { request } from '@/api/_service.js'; // 押金列表

export function listSubsidiary(params) {
  return request({
    url: '/subsidiaryErpNew/getSubsidiaryList',
    method: 'get',
    params: params
  });
}